import { FC, SyntheticEvent, FocusEvent, useState, useEffect } from 'react';
import Image from 'next/image';
import SearchIcon from '../../../assets/svg/search.svg';

export interface Input {
  placeholder: string;
  value: string;
  className?: string;
  disabled?: boolean;
  onChange(value: string): void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
}

const InputSearch: FC<Input> = ({ value, placeholder, disabled, className = '', onChange, onFocus, onBlur }) => {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e: SyntheticEvent<HTMLInputElement>) => {
    setInputValue(e.currentTarget.value);
    onChange(e.currentTarget.value);
  };

  useEffect(() => {
    if (!value) setInputValue(value);
  }, [value]);

  return (
    <div className={`${className} field ${disabled ? 'disabled' : ''}`}>
      <div className="field__input-wrap">
        <input
          id={'text-box'}
          className={`field__input`}
          type={'text'}
          name={'search'}
          onChange={handleInputChange}
          onFocus={onFocus}
          onBlur={onBlur}
          value={inputValue || value}
          autoComplete={'off'}
          placeholder={placeholder}
          disabled={disabled}
        />
        <button type={'button'} className="field__search-ico">
          <Image src={SearchIcon} alt="search icon" />
        </button>
      </div>

      <style jsx>{`
        .field__input {
          display: block;
          width: 100%;
          box-sizing: border-box;
          font-size: 16px;
          line-height: 24px;
          border: 1px solid #ebebeb;
          border-radius: 20px;
          padding: 9px 45px 9px 20px;
          color: #212121;
          outline: none;
          transition: 0.3s;
        }

        .field__input--err {
          border: 1px solid var(--error);
        }

        .field__err {
          font-size: 12px;
          line-height: 18px;
          min-height: 18px;
          margin-top: 5px;
          padding-left: 20px;
          color: var(--error);
          transition: 0.3s;
        }

        .field__input:focus {
          border: 1px solid var(--primary-hover-color);
        }

        .field__input-wrap {
          position: relative;
        }
        .field__input-wrap.disabled {
          opacity: 0.8;
          cursor: default;
          pointer-events: none;
        }

        .field__search-ico {
          position: absolute;
          width: 24px;
          height: 24px;
          top: 10px;
          right: 20px;
          border: none;
          background: transparent;
          padding: 0;
          cursor: pointer;
          outline: none;
        }
      `}</style>
    </div>
  );
};

export { InputSearch };
